import AddAction from './add-actions'

import withRedux from './with-redux'

export default withRedux(AddAction)